import { Component, Input, Output, ViewChild, EventEmitter, AfterViewInit } from '@angular/core';

@Component({
  selector: 'adminapp-upload-zip-modal',
  templateUrl: './upload-history-modal.component.html',
  styleUrls: ['./upload-history-modal.component.scss']
})
export class UploadHistoryModalComponent implements AfterViewInit {

  @ViewChild('actions') progressDialog: any;

  @Input() fileZip;
  @Output() cancel = new EventEmitter<void>();
  @ViewChild('cancelButton') cancelButton: any;

  constructor() {
  }

  ngAfterViewInit(): void {
    this.cancelButton.nativeElement.addEventListener('click', this.onCancel.bind(this));
  }

  open() {
    this.progressDialog.nativeElement.open();
  }

  close() {
    this.progressDialog.nativeElement.close();
  }

  onCancel() {
    this.cancel.emit();
  }
}


